import {
  getAnalytics,
  logEvent,
  setUserId,
  setUserProperties,
} from '@firebase/analytics'
import { initializeApp } from 'firebase/app'
import { getPerformance, trace } from 'firebase/performance'
import { bindAll } from 'lodash'

const firebase = {
  init(config) {
    this.app = initializeApp(config)
    this.analytics = getAnalytics(this.app)
    this.perf = getPerformance(this.app)
  },

  logEvent(eventName, eventParams) {
    return logEvent(this.analytics, eventName, eventParams)
  },

  setUserId(id) {
    setUserId(this.analytics, id)
  },

  setUserProperty(name, value) {
    setUserProperties(this.analytics, { [name]: value })
  },

  getTrace(eventName) {
    return trace(this.perf, eventName)
  },
}

export default bindAll(firebase, [
  'init',
  'logEvent',
  'setUserId',
  'setUserProperty',
])
